import React, { useRef } from 'react';
import ReactPlayerYoutube from 'react-player/youtube';
import { YouTubeWrapper } from './YouTubeWrapper';
export const Youtube = _ref => {
  let {
    src,
    onPlayerReady,
    playing,
    muted,
    onEnd
  } = _ref;
  const playerRef = useRef(new YouTubeWrapper());
  return /*#__PURE__*/React.createElement(ReactPlayerYoutube, {
    url: src,
    onReady: player => {
      var _playerRef$current;
      (_playerRef$current = playerRef.current) == null || _playerRef$current.setPlayer(player);
      onPlayerReady == null || onPlayerReady(playerRef.current);
    },
    playing: playing,
    muted: muted,
    onProgress: progress => {
      var _playerRef$current2;
      return (_playerRef$current2 = playerRef.current) == null ? void 0 : _playerRef$current2.callOnProgress(progress);
    },
    onError: error => {
      var _playerRef$current3;
      return (_playerRef$current3 = playerRef.current) == null ? void 0 : _playerRef$current3.callOnError(error);
    },
    controls: true,
    width: "100%",
    height: "100%",
    "data-hook": "wix-vod-player-youtube",
    onEnded: onEnd
  });
};
//# sourceMappingURL=Youtube.js.map